export default function localePlugin({ locale }) {
  return {
    subscribe({ setContext }) {
      setContext({
        locale,
      })
    },
  }
}
